import { Geometry, GeometryCollection } from 'geojson';
import { ReactNode } from 'react';

/** A geojson Geometry that does not include GeometryCollection */
export type SearchResultGeometry = Exclude<Geometry, GeometryCollection>;

export enum SearchResultType {
  GO_TO_POINT = 'go_to_point',
  MAPBOX_PLACE = 'mapbox_place',
  LAYER_LIBRARY = 'layer_library',
  SAVED_MAP = 'saved_map',
  COUNTY = 'county',
  PARCEL_OWNER_NAME = 'parcel_owner_name',
  PARCEL_OWNER_ADDRESS = 'parcel_owner_address',
  PARCEL_NUMBER = 'parcel_number',
  STATE = 'state',
  TOWNSHIP_RANGE = 'township_range',
  SECTION_TOWNSHIP_RANGE = 'section_township_range',
}

export type SearchResult<T> = {
  /** Unique ID for the search result */
  id: string;
  type: SearchResultType;
  label: string;
  node?: ReactNode;
  geometry: SearchResultGeometry;
  original: T;
  url?: string;
};

export type URLSearchResult<T> = Omit<SearchResult<T>, 'geometry'> & {
  url: string;
};

export type IndexedSearchResult<T> = SearchResult<T> & {
  index: number;
};

export type IndexedURLSearchResult<T> = IndexedSearchResult<T> &
  URLSearchResult<T>;
